import { NuvoThrobber, NuvoThrobberProps } from '@nuvolo/nuux-core/components/NuvoThrobber';
import styled from 'styled-components';

const LoaderDiv = styled.div`
  .loader div {
    background: transparent;
  }
`;

export default function WorkingOnItThrobber(props: NuvoThrobberProps) {
  return (
    <LoaderDiv>
      <div className="loader">
        <NuvoThrobber
          primaryLabel="One"
          primaryDescription="Moment"
          secondaryLabel="Working on it."
          {...props}
        />
      </div>
    </LoaderDiv>
  );
}
